/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ReactMarkdown from 'react-markdown';
import {
    shape, string, object, func,
    bool,
} from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import DialogActions from '@material-ui/core/DialogActions';
import { setUserConfirmationForSubscriptionPopup } from '../../../../state/ducks/App/App-Actions';

const styles = (theme) => ({
    dialogContent: {
        fontSize: '.8em',
    },
    subscriptionMessage: {
        fontSize: '.9em',
        padding: '2em 0',
        margin: '1em 0',
        '& span': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    subscriptionDetailsContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '10px',
    },
    subscriptionDetails: {
        display: 'block',
        fontSize: 14,
        width: 399,
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
        margin: '0 auto',
        '& ul': {
            marginBottom: 0,
            lineHeight: '20px',
            marginTop: 20,
            paddingLeft: 10,
            [theme.breakpoints.down('xs')]: {
                paddingLeft: 40,
                marginTop: 10,
            },

        },
        '& span': {
            textDecoration: 'underline',
            cursor: 'pointer',
            display: 'inline-block',
        },
    },
    dialogHeading: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flex: '0 0 auto',
        '@media screen and (max-width: 600px)': {
            '& >div': {
                width: '80%',
            },
            '& h2': {
                fontSize: '17px',
            },
        },
    },
    closeButton: {
        padding: '16px 24px',
        '@media screen and (max-width: 600px)': {
            padding: '0 0 0 2px',
        },
    },
    closeBtn: {
        position: 'absolute',
        top: '0',
        right: '0',
    },
    popUpHeading: {
        textAlign: 'center',
        '& span': {
            fontSize: '24px',
            [theme.breakpoints.down('md')]: {
                fontSize: '18px',
            },
        },
    },
    bottomContent: {
        margin: '0 auto',
        padding: '20px 0',
        fontSize: '20px',
        fontWeight: '600',
        color: theme.palette.black || '#000',
        textTransform: 'uppercase',
        textDecoration: 'underline',
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
    detailWrapper: {
        borderTop: '1px solid #C4C4C4',
        paddingTop: '28px',
        marginTop: '20px',
        '& ul': {
            width: '307px',
            margin: '0 auto',
            paddingLeft: '10px',
            '& li': {
                fontSize: '14px',
                width: '294px',
                lineHeight: '20px',
                marginBottom: '8px',
            },
            [theme.breakpoints.up('600')]: {
                width: '86.8%',
                '& li': {
                    width: '100%',
                },
            },
        },
        [theme.breakpoints.up('600')]: {
            width: '100%',
            paddingTop: '24px',
        },
    },
});

const renderers = (handleModal) => ({
    linkReference: (props) => {
        const { href, children } = props;
        if (href === '/terms-and-conditions-modal') {
            return (
                <span key={1} role="link" tabIndex={0} onClick={(e) => { handleModal(e, true); }} onKeyDown={(event) => { if (event.keycode === 13); }}>
                    {children}
                </span>
            );
        }
        return children;
    },
});

class SubscriptionPDPInformation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    render() {
        const { open } = this.state;
        const {
            data, copy, classes, handleUserConfirmation, isPdpRedesignEnabled,
        } = this.props;

        const handleModal = (e, windowOpen) => {
            e.nativeEvent.stopImmediatePropagation();
            e.preventDefault();
            e.persist();
            e.stopPropagation();
            this.setState({ open: windowOpen });
        };

        const userConfirmation = () => {
            handleUserConfirmation(true);
            this.setState({ open: false });
        };
        const defaultCopy = (
            <ul>
                <li>Payment method on file will be charged on a recurring basis</li>
                <li>You may cancel through your online account at any time before your next order is processed for delivery or shipment</li>
                <li>To learn more, see <span key={1} role="link" tabIndex={0} onClick={(e) => { handleModal(e, true); }} onKeyDown={(event) => { if (event.keycode === 13); }}>Subscription Program Terms and Conditions</span></li>
            </ul>
        );
        return (

            <>
                <Grid container className={classes.subscriptionDetailsContainer} data-testid="subscription-details">
                    <Grid item xs={12} sm={12}>
                        <Typography className={`${classes.subscriptionDetails} ${isPdpRedesignEnabled ? classes.detailWrapper : ''}`}>
                            {copy ? <ReactMarkdown source={copy} renderers={renderers(handleModal)} escapeHtml={false} /> : defaultCopy}
                        </Typography>
                    </Grid>
                </Grid>
                { open ? (
                    <Dialog data-testid="subscription-terms-condition-modal" open={open}>
                        <DialogTitle className={classes.popUpHeading} id="customized-dialog-title">
                            <span>Subscription Program Terms and Conditions</span>
                            <IconButton className={classes.closeBtn} aria-label="Close" onClick={(e) => { handleModal(e, false); }}>
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <MuiDialogContent className={classes.root}>
                            <Typography gutterBottom className={classes.dialogContent}>
                                <ReactMarkdown source={data.terms} escapeHtml="false" />
                            </Typography>
                        </MuiDialogContent>
                        <DialogActions>
                            <IconButton id="accept-subscription-button" aria-label="close" className={classes.bottomContent} onClick={userConfirmation}>
                                <span>Close</span>
                            </IconButton>
                        </DialogActions>
                    </Dialog>
                ) : null }
            </>

        );
    }
}
SubscriptionPDPInformation.propTypes = {
    data: shape({
        terms: string.isRequired,
    }).isRequired,
    classes: object.isRequired,
    handleUserConfirmation: func.isRequired,
    copy: string.isRequired,
    isPdpRedesignEnabled: bool,
};
SubscriptionPDPInformation.defaultProps = {
    isPdpRedesignEnabled: false,
};

const mapDispatchToProps = (dispatch) => ({
    handleUserConfirmation: bindActionCreators(setUserConfirmationForSubscriptionPopup, dispatch),
});

const styledSubscriptionPDPInformation = withStyles(styles)(SubscriptionPDPInformation);
export default connect(null, mapDispatchToProps)(styledSubscriptionPDPInformation);
